import { auth } from "services/firebase";
import { platformFetch } from "services/platformFetch";
async function request(options = {}) {
  if (!auth?.currentUser) throw new Error("Entre na sua conta para continuar.");
  const response = await platformFetch("/api/admin/coverage-settings", {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await auth.currentUser.getIdToken()}`,
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok)
    throw new Error(body.message || "Não foi possível acessar a regra de cobertura.");
  return body;
}
export const getCoverageSettings = () => request();
export const saveCoverageSettings = (settings) =>
  request({ method: "PUT", body: JSON.stringify(settings) });
